module.exports = __webpack_public_path__ + "static/media/sna_1.8bb3b8bc.png";